function screenNavInit() {
	let spyControls = document.querySelectorAll(
		".product-screens__controls li a"
	)[0];
	if (spyControls && window.innerWidth < 1024) {
		const spy = new Gumshoe(".product-screens__controls li a", {
			events: true,
			offset: getHeaderHeight(),
		});
	}

	const spyScreen = document.querySelectorAll(".product-screens__screen")[0];
	if (spyScreen && window.innerWidth < 1024) {
		setAttribute(spyScreen.id);
	}
	document.addEventListener(
		"gumshoeActivate",
		function(event) {
			setAttribute(event.detail.content.id);
		},
		false
	);
	function setAttribute(id) {
		document
			.querySelector(".product-screens")
			.setAttribute("data-active-screen", id);
	}
}

function getHeaderHeight() {
	return window.innerWidth < 1024
		? window.innerHeight / 1.5
		: window.innerHeight / 3;
}
